const loadedComponents = [];
let componentsConfig = {};

const init = (selector, path) => {
	let bodyDataset = document.querySelector(`body`).dataset.adtJsComponents;

	if (
		Object.keys(componentsConfig).length === 0 && typeof bodyDataset !== 'undefined'
	) {
		componentsConfig = JSON.parse(bodyDataset);
	}

	$.nette.ext('live').after(function($el) {
		// component is already loaded
		if (loadedComponents.includes(path)) return;

		// there is no element using this component
		if (!document.querySelector(`[data-${selector}]`)) return;

		loadedComponents.push(path);
		if (path.includes('/')) {
			import('./' + path + '/index.js').then(component => {
				component.default.run(document.querySelector(`[data-${selector}]`), $el);
			});

		} else {
			import('./' + path + '/index.js').then(component => {
				component.default.run(document.querySelector(`[data-${selector}]`), $el);
			});
		}
	});
};

const initRecaptcha = () => {
	init('recaptcha', 'Recaptcha');
};



export default {
	init,
	initRecaptcha,
};